import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://emailportalapi.twilightfinland.eu/api'
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect to login on 401 (unauthorized) errors, not 403 (forbidden)
    if (error.response?.status === 401) {
      // Check if it's a token-related issue (invalid/expired token)
      const errorMessage = error.response?.data?.message || '';
      
      if (errorMessage.includes('Not authorized') || errorMessage.includes('token') || errorMessage.includes('User not found')) {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
